import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CustomButton } from '@/components/uiWrappers/button';
import { College } from '@mightybyte/business';

interface UniversitySelectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (college?: College) => void;
  isLoading?: boolean;
  title?: string;
  description?: string;
  allLabel?: string;
}

export function UniversitySelectDialog({
  open,
  onOpenChange,
  onSelect,
  isLoading = false,
  title = 'Select University',
  description = 'Choose which university data to export',
  allLabel = 'All Universities',
}: UniversitySelectDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          <CustomButton
            type="button"
            onClick={() => onSelect()}
            disabled={isLoading}
            variant="outline"
            size="lg"
            className="w-full justify-start"
          >
            {allLabel}
          </CustomButton>
          <CustomButton
            type="button"
            onClick={() => onSelect(College.LMU)}
            disabled={isLoading}
            variant="outline"
            size="lg"
            className="w-full justify-start"
          >
            LMU Only
          </CustomButton>
          <CustomButton
            type="button"
            onClick={() => onSelect(College.Lehigh)}
            disabled={isLoading}
            variant="outline"
            size="lg"
            className="w-full justify-start"
          >
            Lehigh Only
          </CustomButton>
        </div>

        <DialogFooter showCloseButton />
      </DialogContent>
    </Dialog>
  );
}
